import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './BestRecipes.css';
import './ResponsiveRecipes.css';
import { RecipePost } from './Post/RecipePost';
import { RECIPES_DATA } from '../../../data/recipesData';
import { AppDownloadModal } from '../../common/AppDownloadModal';

export const BestRecipes = () => {
    const [isAppModalOpen, setIsAppModalOpen] = useState(false);
    const [selectedRecipeTitle, setSelectedRecipeTitle] = useState('');
    const navigate = useNavigate();

    const handleSeeRecipe = (recipe) => {
        setSelectedRecipeTitle(`Download app to cook "${recipe.title}"`);
        setIsAppModalOpen(true);
    };

    return (
        <section className="bRecipes">
            <div className="recipes">
                <div className="infos">
                    <h2>Our Best Recipes</h2>
                    <p>Explore delicious community-crafted healthy recipes created by master home chefs.</p>
                </div>
                
                <div className="recipe-posts">
                    {RECIPES_DATA.slice(0, 6).map((recipe) => (
                        <RecipePost 
                            key={recipe.id}
                            recipe={recipe}
                            onClick={() => handleSeeRecipe(recipe)}
                        />
                    ))}
                </div>

                <div style={{ textAlign: "center", marginTop: "2.5rem" }}>
                    <button 
                        className="mainBtn" 
                        onClick={() => navigate('/recipes')}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            padding: "0.6rem 1.5rem",
                            fontSize: "0.88rem",
                            borderRadius: "20px",
                            backgroundColor: "#402864",
                            color: "#ffffff",
                            border: "none",
                            cursor: "pointer",
                            fontFamily: "Poppins",
                            fontWeight: "600"
                        }}
                    >
                        Explore All Recipes <FaArrowRight />
                    </button>
                </div>
            </div>

            <AppDownloadModal 
                isOpen={isAppModalOpen}
                onClose={() => setIsAppModalOpen(false)}
                title={selectedRecipeTitle || "Get the ShareRecipe App"}
            />
        </section>
    );
};